import react , {useEffect, useState} from 'react';
import { collection, addDoc, getFirestore } from 'firebase/firestore';

function Importar(){
    const [csv,setCsv] = useState(null);
    const db = getFirestore();
    const parseCSV = (text) =>{
        const result = {
           header: [],
           data: [],
        }
        const [header, ...content] = text.split('\n');
        result.header = header.split(';');
        content.forEach((item) => {
          result.data.push(item.split(';'));
        })
        const resu = result.header.map((headerName) =>{
          console.log(headerName);
        });
        const linha = result.data.map((row, index) =>{
             const coluna = row.map((col) => {
              


             })
              console.log("Leitura => ", row[0]);
              console.log("Leitura => ", row[1]);
              console.log("Leitura => ", row[2]);
              console.log("Leitura => ", row[3]);
              console.log("Leitura => ", row[4]);
              console.log("Leitura => ", row[5]);
//               const docRef = addDoc(collection(db, "clientes"), {
               const docRef = addDoc(collection(db, "acoes"), {
//                nome: row[0],
//                siape: row[1],
//                cpf: row[2],
//                endereco: row[3],
//                bairro: row[4],
//                cidade: row[5],
//                estado: row[6],
//                cep: row[7],
//                fone: row[8],
//                email: row[9],
//                lotacao: row[10],
//                processo: row[11],
//                valor: row[12],
//                urlcart: row[14],
//                alter: row[15],
//                obs1: row[16],
//                lixo: row[17]
                acao: 'ACAO PSS SOBRE 1/3 DE FÉRIAS',
                cpf: row[2],
                situacao: 'EM ANDAMENTO',
                processo: row[11],
                valor: row[12],
                data: row[13]
              })
        })
    return 
      <table>
        <thead>
          <tr>
          {csv.header.map((headerName) =>
          <th key={headerName}>{headerName}</th>)}
          </tr>
        </thead>
        <tbody></tbody>
      </table>
      };

    useEffect(() => {
      fetch('/Transf24_5.csv')
      .then((r) => r.text())
      .then((text) => {
        setCsv(parseCSV(text));
      });
    },[]);
}
export default Importar;
